import { BaseModel } from "../base.model";
import { CustomFieldModel } from "../document/custom-field-model";
import { DocumentStatus, TemplateDocumentType } from "../document/document-template-model";

export enum MyfileTypes {
    Pending = 0, //requires Admin approval
    Onboarding = 1, 
    Approved = 2,
    Disabled = 3,
    PasswordReset = 4
  }

export class MyfileModel extends BaseModel {
    sourceId?: string;
    name?:	string;
    document?: any;
    imageUrl?:	string;
    status?: DocumentStatus;
    type?: TemplateDocumentType;
    customFields?: CustomFieldModel[] = [];
    signedDate?:	string; 
    approvedById?:	string;
    approvedDate?:	string; 
    completedById?:	string 
    completedDate?:	string;   
    number?: string;
    fileSize?: number;
}
